/*
 * DGA-component-product-addons.js
 * Kopie van component-product-addons.js (DGA-aangepaste versie).
 * Verschillen t.o.v. origineel:
 *  - Bindt aan custom element <dga-product-addons> (geen conflict met origineel).
 *  - Ondersteunt naast aan/uit-opties (checkbox) ook aantal-opties (stepper 0..max)
 *    via inputs name="addons_qty[]" met data-variant en data-price.
 *  - Markeert geselecteerde kaarten met de class .dga-selected (rand-highlight).
 * Origineel (assets/component-product-addons.js) blijft ongewijzigd.
 */
if (!customElements.get('dga-product-addons')) {
  customElements.define(
    'dga-product-addons',
    class DgaProductAddons extends HTMLElement {
      constructor() {
        super();

        this.productForm = document.querySelector('product-form.product-form');
        this.productGroupID = this.productForm.querySelector('#product_group_id');
        this.productID = this.productForm.querySelector('input.product-variant-id');
        this.checkboxes = this.querySelectorAll('input[name="addons[]"]');
        this.qtyInputs = this.querySelectorAll('input[name="addons_qty[]"]');
        this.submit = this.querySelector('button[name="add"]');
        this.quantity = this.querySelector('input[name="quantity"]');
        this.progressBar = this.querySelector('#addons-progress-bar');
        this.priceTotal = this.querySelector('#price-total');
        this.priceRegular = this.priceTotal ? this.priceTotal.querySelectorAll('.price-item--regular') : [];

        // Form submit
        this.submit.addEventListener('click', this.handleSubmit.bind(this));

        // Aan/uit-opties (checkbox)
        this.checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', this.onCheckboxChange.bind(this));
        });

        // Aantal-opties (stepper)
        this.querySelectorAll('.dga-stepper').forEach((stepper) => {
          const input = stepper.querySelector('input[name="addons_qty[]"]');
          const minus = stepper.querySelector('.dga-step-minus');
          const plus = stepper.querySelector('.dga-step-plus');
          if (minus && input) minus.addEventListener('click', () => this.stepQty(input, -1));
          if (plus && input) plus.addEventListener('click', () => this.stepQty(input, 1));
          if (input) {
            input.addEventListener('input', () => { this.clampQty(input); this.afterChange(); });
            input.addEventListener('change', () => { this.clampQty(input); this.afterChange(); });
          }
        });

        this.refreshSelected();
      }

      onCheckboxChange(event) {
        this.selectOnlyOne(event);
        this.afterChange();
      }

      afterChange() {
        this.updateProgressBar();
        this.updateTotalPrice();
        this.refreshSelected();
      }

      stepQty(input, dir) {
        const cur = parseInt(input.value) || 0;
        input.value = cur + dir;
        this.clampQty(input);
        this.afterChange();
      }

      clampQty(input) {
        let v = parseInt(input.value);
        const min = parseInt(input.min) || 0;
        const max = parseInt(input.max);
        if (isNaN(v)) v = min;
        if (v < min) v = min;
        if (!isNaN(max) && v > max) v = max;
        input.value = v;
      }

      // Geeft elke geselecteerde kaart de rand-highlight (zoals het origineel via :checked)
      refreshSelected() {
        this.querySelectorAll('.dga-opt').forEach((card) => {
          const cb = card.querySelector('input[name="addons[]"]');
          const qty = card.querySelector('input[name="addons_qty[]"]');
          let selected = false;
          if (cb && cb.checked) selected = true;
          if (qty && (parseInt(qty.value) || 0) > 0) selected = true;
          card.classList.toggle('dga-selected', selected);
        });
      }

      selectOnlyOne(event) {
        const target = event.target;
        if (target.dataset.onlyOne) {
          this.checkboxes.forEach((checkbox) => {
            if (
              checkbox !== target &&
              checkbox.dataset.onlyOne === target.dataset.onlyOne
            ) {
              checkbox.checked = false;
            }
          });
        }
      }

      handleSubmit(event) {
        event.preventDefault();

        const items = [];

        // Aan/uit-opties: hoeveelheid = globale producthoeveelheid (zoals origineel)
        this.checkboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            items.push({
              id: checkbox.value,
              quantity: this.quantity.value,
              properties: {
                addon_group_id: `${this.productGroupID.value}`,
                product_id: `${this.productID.value}`
              }
            });
          }
        });

        // Aantal-opties: hoeveelheid = gekozen aantal (0 = overslaan)
        this.qtyInputs.forEach((qtyInput) => {
          const q = parseInt(qtyInput.value) || 0;
          if (q > 0) {
            items.push({
              id: qtyInput.dataset.variant,
              quantity: q,
              properties: {
                addon_group_id: `${this.productGroupID.value}`,
                product_id: `${this.productID.value}`
              }
            });
          }
        });

        if (items.length > 0) {
          this.addProductsToCart(items);
        } else {
          this.productForm.querySelector('button[name="add"]').click();
        }
      }

      addProductsToCart(items) {
        const formData = { items };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(response => response.json())
          .then(() => {
            this.productForm.querySelector('button[name="add"]').click();
            this.productGroupID.value = parseFloat(this.productGroupID.value) + 1;
          })
          .catch((error) => {
            console.error('Error adding products:', error);
          });
      }

      updateProgressBar() {
        if (!this.progressBar) return;

        this.maxProgress = this.checkboxes.length;
        const checkedCount = Array.from(this.checkboxes).filter(checkbox => checkbox.checked).length;
        const progressPercentage = this.maxProgress ? (checkedCount / this.maxProgress) * 100 : 0;
        this.progressBar.style.width = `${progressPercentage}%`;
      }

      updateTotalPrice() {
        let basePrice = 0;

        if (this.priceTotal && this.priceTotal.dataset.price) {
          basePrice = parseInt(this.priceTotal.dataset.price) || 0;
        }

        let addonsTotal = 0;

        this.checkboxes.forEach((checkbox) => {
          if (checkbox.checked && checkbox.dataset.price) {
            addonsTotal += parseInt(checkbox.dataset.price) || 0;
          }
        });

        this.qtyInputs.forEach((qtyInput) => {
          const q = parseInt(qtyInput.value) || 0;
          const p = parseInt(qtyInput.dataset.price) || 0;
          addonsTotal += q * p;
        });

        const total = basePrice + addonsTotal;

        this.priceRegular.forEach((priceRegular) => {
          const priceAmountElement = priceRegular.querySelector('.price-amount');
          if (priceAmountElement) {
            priceAmountElement.innerText = Shopify.formatMoney(total, '{{amount_with_decimals_no_comma_separator}}');
          }
        });
      }
    }
  );
}
